<template>
    <div class="admin-files">
        <fieldset>
            <legend>
                <button @click="$modal.show(fileable_id)" class="btn btn-success pull-left" :disabled="loading">
                    Create File
                </button>

                Files
            </legend>

            <modal :name=fileable_id
                   :adaptive="true"
                   :scrollable="true"
                   height="auto">
                <div class="dashboard-block" :class="{loading: loading}">
                    <form @submit.prevent="submitFile" method="POST"
                          accept-charset="UTF-8"
                          class="margin-md-top"
                          enctype="multipart/form-data" novalidate="novalidate">
                        <header>
                            <h4>Create File</h4>
                        </header>

                        <div class="form-group has-feedback" :class="{'has-error': errors.has('File[file]')}">
                            <input v-validate="'required'"
                                   aria-required="true"
                                   required="true"
                                   id="file-file"
                                   name="File[file]"
                                   type="file"
                                   class="form-control dropable"
                                   @change="onFileChange">

                            <span v-show="errors.has('File[file]')" class="help-block">
                                {{ errors.first('File[file]') }}
                            </span>
                        </div>

                        <hr>

                        <div class="row">
                            <div class="col-sm-6 col-ld-4 form-group pull-right">
                                <button type="submit" class="btn btn-success btn-block" :disabled="loading">
                                    Save File
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </modal>

            <div class="files-wrapper">
                <div v-for="(file, index) in displayFiles" class="file" :key="file.id">
                    <h5 class="day"
                        v-if="index === 0 || files[index - 1].created_at.clone().startOf('day').day() !== file.created_at.clone().startOf('day').day()">
                        {{ file.created_at.local().format('ddd, MMMM Do') }}
                    </h5>

                    <h5 class="user">
                        <span class="user-name">
                            {{file.user.first_name}} {{file.user.last_name}}
                        </span>
                        <span class="created-at">
                            {{ file.created_at.local().format('h:mm a') }}
                        </span>

                        <a href="javascript://void(0)"
                           :disabled="loading"
                           @click="removeFile(file)"
                           class="btn btn-xs btn-danger">
                            Remove
                        </a>
                    </h5>

                    <a :href="'/files/' + file.id + '/download'"
                       class="truncate margin-sm-left display-block"
                       target="_blank">
                        <i class="fa fa-file-o" aria-hidden="true"></i>&nbsp;{{file.name}}
                    </a>
                </div>

                <a href="javascript://void(0)" @click="toggleShowAll" v-if="files.length > 3 && !showAll">
                    Show All Files
                </a>
            </div>
        </fieldset>
    </div>
</template>

<script>
    export default {
        props: {
            fileable_id: {
                required: true,
                type: String
            },

            fileable_type: {
                required: true,
                type: String
            },

            user_id: {
                required: true,
                type: String
            },
        },

        data(){
            return {
                loading: true,
                showAll: false,
                files: [],
                file: null
            };
        },

        mounted(){
            this.loadFiles()
                .catch( this.$root.handleErrors )
                .finally( () => {
                    this.loading = false;
                } );
        },

        computed: {
            displayFiles(){
                if( !this.showAll && this.files.length > 3 ){
                    return _.slice( this.files, 0, 3 );
                }
                else {
                    return this.files;
                }
            },

            buttonClass(){
                if( this.showCreate ){
                    return 'btn-default';
                }
                else {
                    return 'btn-primary';
                }
            }
        },

        methods: {
            loadFiles(){
                var url = '/api/files?fileable_id=' + this.fileable_id +
                    '&fileable_type=' + this.fileable_type +
                    '&sort_by=created_at&sort_dir=DESC';

                return axios.get( url )
                    .then( ( response ) => {
                        this.files = response.data.Files.map( ( file ) => {
                            file.created_at = new moment.utc( file.created_at );

                            return file;
                        } );
                    } )
                    .catch( this.$root.handleErrors );
            },

            removeFile( file ){
                this.loading = true;

                return axios.delete( '/api/files/' + file.id )
                    .then( this.loadFiles )
                    .finally( () => {
                        this.loading = false;
                    } )
                    .catch( this.$root.handleErrors );
            },

            toggleShowAll(){
                this.showAll = !this.showAll;
            },

            submitFile(){
                this.$validator.validateAll()
                    .then( ( valid ) => {
                        if( valid ){
                            var data = new FormData();

                            data.append( 'File[fileable_id]', this.fileable_id );
                            data.append( 'File[fileable_type]', this.fileable_type );
                            data.append( 'File[file]', this.file );
                            data.append( 'File[name]', this.file.name );
                            data.append( 'File[type]', this.file.type );

                            this.loading = true;

                            return axios.post( '/api/files', data, {
                                headers: {
                                    'Content-Type': 'multipart/form-data'
                                }
                            } )
                                .then( () => {
                                    this.$modal.hide( this.fileable_id );
                                    $( this.$el ).find( 'input[type="file"]' ).val( null );

                                    return this.loadFiles();
                                } )
                                .finally( () => {
                                    this.loading = false;
                                } )
                                .catch( this.$root.handleErrors );
                        }
                    } );

                return false;
            },

            onFileChange( e ){
                this.file = e.target.files[ 0 ];
            },
        }
    }
</script>